import { Meal } from 'fitbeat.models';
import { InMemoryMealRepository } from '../in-memory/in-memory-meal-repository';
import { IMealRepository } from '../interfaces/imeal-repository';

// cached for the duration of the process
// todo we need a daily cache invalidation or other strategy
export class CachedMealRepository implements IMealRepository {
    private inMemoryMealRepository: InMemoryMealRepository;

    constructor(private underlyingRepository: IMealRepository) { }

    public async getInMemInstance(): Promise<InMemoryMealRepository> {
        if (this.inMemoryMealRepository == null) {
            const allMeals = await this.underlyingRepository.getAll();
            this.inMemoryMealRepository = new InMemoryMealRepository();
            this.inMemoryMealRepository.setAllMeals(allMeals);
        }
        return this.inMemoryMealRepository;
    }

    public async getAll(): Promise<Meal[]> {
        return await (await this.getInMemInstance()).getAll();
    }
    public async get(uid: string): Promise<Meal | undefined> {
        return await (await this.getInMemInstance()).get(uid);
    }
    public async getMealsForMealPlan(mealPlanId: string): Promise<Meal[]> {
        return await (await this.getInMemInstance()).getMealsForMealPlan(mealPlanId);
    }
    public async getAllMealsForTimeOfDay(
        timeOfDay: string, gender: string, dietGoal: string, foodPreference: string,
        organisation?: string): Promise<Meal[]> {
            return await (await this.getInMemInstance()).getAllMealsForTimeOfDay(
                timeOfDay, gender, dietGoal, foodPreference, organisation);
    }

    public add(meal: Meal): Promise<Meal> {
        throw new Error('Method not implemented.');
    }
    public async getImage(uid: string): Promise<string> {
        return await this.underlyingRepository.getImage(uid);
    }
    public setImage(uid: string, base64Image: string): Promise<boolean> {
        throw new Error('Method not implemented.');
    }
    public update(meal: Meal): Promise<Meal> {
        throw new Error('Method not implemented.');
    }
    public setThumbnail(uid: string, base64Image: string): Promise<boolean> {
        throw new Error('Method not implemented.');
    }
    public async getThumbnail(uid: string): Promise<string> {
        return await this.underlyingRepository.getThumbnail(uid);
    }
    public async getThumbnails(mealPlanId: string): Promise<string[]> {
        return await this.underlyingRepository.getThumbnails(mealPlanId);
    }
}
